<mat-card appearance="outlined" class="mat-elevation-z1 mat-card-scrollable">
    @if (infomaterials.length > 0) {
        <mat-card-header>
            <mat-card-title>{{ 'Contact.Infomaterial' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="container">
            <div class="mb-2">
                {{ 'Contact.InfomaterialClick' | translate }}
            </div>
            <div class="row no-gutters">
                @for (item of infomaterials; track item.id) {
                    <div class="col-12 col-sm-8">
                        <mat-checkbox [checked]="item.isSelected" (change)="onChange(item)">
                            {{ item.description }}
                        </mat-checkbox>
                    </div>
                }
            </div>
        </mat-card-content>
    } @else {
        <ng-container>{{ (isLoading ? 'General.Loading' : 'General.NoData') | translate }}...</ng-container>
    }
</mat-card>
